import script from "./AddDentalIpdBill.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDentalIpdBill.vue?vue&type=script&setup=true&lang=js"

import "./AddDentalIpdBill.vue?vue&type=style&index=0&id=427fbfa1&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-427fbfa1"]])

export default __exports__